import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";

const initialForm = {
  page_title: "",
  map_iframe_url: "",
  email: "",
  phone: "",
  address: "",
};

const ContactSectionDashboard = () => {
  const [contactData, setContactData] = useState(null);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  useEffect(() => {
    fetchContactSection();
  }, []);

  const fetchContactSection = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/contact-section");
      const data = await res.json();

      if (data && data.id) {
        setContactData(data);
        setEditingId(data.id);

        setForm({
          page_title: data.page_title || "",
          map_iframe_url: data.map_iframe_url || "",
          email: data.email || "",
          phone: data.phone || "",
          address: data.address || "",
        });
      } else {
        setContactData(null);
        setEditingId(null);
        setForm(initialForm);
      }
    } catch (error) {
      console.error("Error fetching contact section:", error);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setBannerImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    if (bannerImage) {
      formData.append("banner_image", bannerImage);
    }

    try {
      const url = editingId
        ? `https://admin.drgargevascular.com/backend/contact-section/${editingId}`
        : "https://admin.drgargevascular.com/backend/contact-section";

      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        body: formData,
      });

      if (!res.ok) throw new Error("Failed request");

      setMessage(
        editingId
          ? "Contact section updated successfully!"
          : "Contact section added successfully!"
      );
      setMessageType("success");

      fetchContactSection();

      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 4000);
    } catch (error) {
      console.error(error);
      setMessage("Something went wrong. Please try again.");
      setMessageType("error");

      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 4000);
    }
  };

  return (
    <>
      <PageTitle activeMenu="Contact Section" motherMenu="Dashboard" />

      <div className="row">
        <div className="col-xl-12">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h4 className="mb-0 fw-bold">
                {editingId ? "Edit Contact Section" : "Add Contact Section"}
              </h4>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Page Title</label>
                    <input
                      type="text"
                      name="page_title"
                      className="form-control"
                      value={form.page_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Banner Image</label>
                    <input
                      type="file"
                      name="banner_image"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Google Map Embed URL</label>
                    <textarea
                      name="map_iframe_url"
                      className="form-control"
                      rows="3"
                      value={form.map_iframe_url}
                      onChange={handleChange}
                      placeholder="Paste only iframe src URL"
                    ></textarea>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Phone</label>
                    <input
                      type="text"
                      name="phone"
                      className="form-control"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Address</label>
                    <textarea
                      name="address"
                      className="form-control"
                      rows="4"
                      value={form.address}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  {message && (
                    <div className="col-md-12">
                      <div
                        className={`alert ${
                          messageType === "success"
                            ? "alert-success"
                            : "alert-danger"
                        }`}
                        style={{
                          fontSize: "14px",
                          borderRadius: "8px",
                          padding: "10px 15px",
                        }}
                      >
                        {message}
                      </div>
                    </div>
                  )}

                  <div className="col-md-12 mt-2">
                    <button className="btn btn-primary px-4">
                      {editingId ? "Update Contact Section" : "Save Contact Section"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* PREVIEW */}
        <div className="col-xl-12 mt-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h4 className="mb-0 fw-bold">Current Preview</h4>
            </div>

            <div className="card-body">
              {contactData ? (
                <div className="row">
                  <div className="col-md-4">
                    {contactData.banner_image && (
                      <img
                        src={`https://admin.drgargevascular.com/backend${contactData.banner_image}`}
                        alt="banner"
                        style={{
                          width: "100%",
                          borderRadius: "12px",
                          objectFit: "cover",
                          maxHeight: "220px",
                        }}
                      />
                    )}
                  </div>

                  <div className="col-md-8">
                    <h4>{contactData.page_title}</h4>
                    <p><strong>Email:</strong> {contactData.email}</p>
                    <p><strong>Phone:</strong> {contactData.phone}</p>
                    <p><strong>Address:</strong> {contactData.address}</p>
                    <p>
                      <strong>Map URL:</strong><br />
                      <span style={{ fontSize: "13px", color: "#666" }}>
                        {contactData.map_iframe_url}
                      </span>
                    </p>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5 text-muted">
                  No Contact Section data found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactSectionDashboard;